<template>
  <SettleBillList :fixed-status="1" />
</template>
<script lang="ts" setup>
import SettleBillList from './SettleBillList.vue'
defineOptions({ name: 'TradeAreaAgentSettleStatus1' })
</script>
